import { render, staticRenderFns } from "./CancionDetail.vue?vue&type=template&id=55a1c2f3&scoped=true"
import script from "./CancionDetail.vue?vue&type=script&lang=js"
export * from "./CancionDetail.vue?vue&type=script&lang=js"
import style0 from "./CancionDetail.vue?vue&type=style&index=0&id=55a1c2f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1c2f3",
  null
  
)

export default component.exports